import useI18n from 'contexts/I18n/hook'
import { CardSizes } from 'core/card/enum'
import PopUp from 'core/pop-up'
import React, { useMemo, useState } from 'react'
import { translate } from '../utils'

type NewPlatformModalProps = {
  existingPlatforms: Array<string>
  onCancel: () => void
  onConfirm: (platformName: string) => void
}

export default function NewPlatformModal({
  existingPlatforms,
  onCancel,
  onConfirm,
}: NewPlatformModalProps) {
  const t = useI18n()
  const [platformName, setPlatformName] = useState('')

  const platformAlreadyExists = useMemo(
    () =>
      existingPlatforms.some(
        (platform) => platform.toLowerCase() === platformName.trim().toLowerCase()
      ),
    [existingPlatforms, platformName]
  )
  const confirmDisabled = !platformName.trim() || platformAlreadyExists

  const handleConfirm = () => {
    if (confirmDisabled) {
      return
    }

    onConfirm(platformName.trim())
  }

  return (
    <PopUp isActive size={CardSizes.MEDIUM}>
      <div className="bootstrap-modal">
        <h4 className="title is-4 bootstrap-modal-title">
          {translate(t, 'bootstrap.new_platform_title')}
        </h4>
        <div className="field">
          <input
            className="input"
            value={platformName}
            onChange={(event) => setPlatformName(event.target.value)}
            placeholder={translate(t, 'bootstrap.platform_name_placeholder')}
          />
          {platformAlreadyExists && (
            <p className="help is-danger">
              {translate(t, 'bootstrap.platform_already_exists')}
            </p>
          )}
        </div>
        <div className="bootstrap-modal-actions">
          <button
            type="button"
            className="button is-larger is-primary"
            disabled={confirmDisabled}
            onClick={handleConfirm}
          >
            {translate(t, 'general.confirm')}
          </button>
          <button type="button" className="button is-larger" onClick={onCancel}>
            {translate(t, 'general.cancel')}
          </button>
        </div>
      </div>
    </PopUp>
  )
}
